export default __webpack_public_path__ + "static/media/carousel5.f964320b.jpeg";